import React from 'react'
import { 
    Button
    } from '@mui/material';

import PrintIcon from '@mui/icons-material/Print';


const PrintButton = ({...props}) => {

    const { componentRef, handlePrint } = props;

    return (
        <Button 
            variant="contained" 
            type="button" 
            color="primary"
            startIcon={<PrintIcon />}
            onClick={e => handlePrint(componentRef)}>
                Print </Button>
    )
}

export default PrintButton;